import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TasteMapComponent } from "./taste-map/taste-map.component";

const routes: Routes = [
  { path: ":username", component: TasteMapComponent },
  { path: "**", redirectTo: "/" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
